module.exports = __webpack_public_path__ + "static/media/1004408.eac55768.jpg";